import * as cq from '@os/cloudquote';

/**
 * utility method that provides stock info for competitor stocks
 * @param symbol {String} The symbol to pass to cloudquote's getCompetitors method
 * @returns {Promise} Promise that when resolved contains an an object of the form {rows: []} where each entry in the rows array is the result of the call to getStockPrice for each of the competitor stocks
 *
 */
const getCompetitorStockData = (symbol) => cq.getCompetitors(symbol)
	.then( (competitors={}) => {
		if (!competitors.rows) competitors.rows = [];
		return Promise.all(
			competitors.rows.map( (competitor) => (
				cq.getStockPrice(competitor.symbol).then( (stock) => {
					if (stock.rows[0]) {
						stock.rows[0].MarketCap = competitor.marketCap;
					}
					return stock.rows[0];
				})
			))
		);
	})
	.then( data => ({ rows: data }));

/**
 * Model factory for finance data to be used with @os/model-connect
 *
 * @returns {Object} With all @os/cloudquote methods exposed, plus getCompetitorStockData
 */
export default function financeModel() {
	let model = { getCompetitorStockData };
	Object.keys(cq).forEach(key => model[key] = cq[key]);
	return model;
}

import config from './config';
export { config };
